import { useQueries } from '@tanstack/react-query';
import { useMemo } from 'react';

type AdviceDto = {
  id: string;
  clientId: string;
  dataExportTemplateId?: string | null;
  dataUploadFileId?: string | null;
  content?: string | null;
  adviceClass?: string | null;
  summary?: string | null;
  createdAt?: string | null;
};

export function useFilesWithAdvice(fileIds: string[]) {
  const queries = useQueries({
    queries: fileIds.map(fileId => ({
      queryKey: ['advice', fileId],
      enabled: !!fileId,
    })),
  });

  const isLoading = queries.some(q => q.isLoading);

  const fileIdsWithAdvice = useMemo(() => {
    if (isLoading) return new Set<string>();

    const result = new Set<string>();
    queries.forEach((query, index) => {
      const advice = query.data as AdviceDto[] | undefined;
      if (!advice || advice.length === 0) return;

      const hasRealAdvice = advice.some(a => a.adviceClass !== 'NO_ADVICE_DETECTED');
      if (hasRealAdvice) {
        result.add(fileIds[index]);
      }
    });
    return result;
  }, [queries, fileIds, isLoading]);

  return { fileIdsWithAdvice, isLoading };
}
